import React from 'react';
interface SlideContainerProps {
  children: React.ReactNode;
  className?: string;
  centered?: boolean;
}
export const SlideContainer = ({
  children,
  className = '',
  centered = false
}: SlideContainerProps) => {
  return <section className={`min-h-screen w-full flex flex-col justify-center px-6 py-24 md:px-12 lg:px-24 mx-auto max-w-6xl ${centered ? 'items-center text-center' : ''} ${className}`} data-id="element-13">
      {children}
    </section>;
};